import FBaseService from '../FBaseService';
import { AxiosResponse } from 'axios';
import { HeaderData, SessionData, PortalAppStatus } from './types';
import { NoticeClass, NoticeResponse } from '../../store/modules/types/Notice';
import Alert from '../../store/modules/types/Alert';
import { ResponseEnvelope } from '..';

export default class AuthService extends FBaseService {

	readonly SESSION_ENDPOINT = '/session';
	readonly PORTAL_HEADER_ENDPOINT = '/session/portal-header';
	readonly APP_STATUS_ENDPOINT = '/session/portalapp-status';

	buildUrl(url: string): string {
		return (this.useApi ? '/api' : '') + url;
	}

	getSession(): Promise<AxiosResponse<SessionData>> {
		return this.apiClient.get<SessionData>(this.buildUrl(this.SESSION_ENDPOINT));
	}
	
	getPortalHeader(): Promise<AxiosResponse<HeaderData>> {
		return this.apiClient.get<HeaderData>(this.buildUrl(this.PORTAL_HEADER_ENDPOINT));
	}

	getPortalAppStatus(): Promise<AxiosResponse<ResponseEnvelope<PortalAppStatus>>> {
		return this.apiClient.get<ResponseEnvelope<PortalAppStatus>>(this.buildUrl(this.APP_STATUS_ENDPOINT));
	} 

	protected async handleUnauthenticated(url: string): Promise<void> {
		window.location.assign(this.getAuthLoginCallbackUrl(url));
	}

	protected async handleForbidden(): Promise<void> {
		const msg = 'You are not authorized for this application.  Please contact your FIRSTBase administrator.';
		if (this.store !== null) {
			const al = new Alert(msg, NoticeClass.ERROR);
			al.setAcceptLabel('FIRSTBASE HOME');
			await this.store.dispatch('notices/add', al).then((ok) => {	
				switch (ok) {
					case NoticeResponse.ACCEPT: 
						window.location.assign(`https://base.kasasaonline.com`); // we don't have users' API model with base address yet.
						break;
				}
			});
		} else {
			alert(msg);
		}
		return;
	}
}